import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import styles from './css/FormLabel.scss';

export default function FormLabel({
    children,
    className,
    required,
    ...props
}) {
    const classes = classNames(styles.label, className);
    return (
        <label {...props} className={classes}>
            {children}
            {required && (<span className={styles.required}>*</span>)}
        </label>
    );
}

FormLabel.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    required: PropTypes.bool,
};
